export default __webpack_public_path__ + "54685fcaafea3016f23b7acf1a8be944.png";